module.exports = __webpack_public_path__ + "static/img/蒙版组 11@2x.5f7956be.png";